import React from 'react';
import like from '../../../media/images/reaction/like.svg';
import love from '../../../media/images/reaction/love.svg';
import care from '../../../media/images/reaction/care.svg';
import wow from '../../../media/images/reaction/wow.svg';
import haha from '../../../media/images/reaction/haha.svg';
import sad from '../../../media/images/reaction/sad.svg';
import angry from '../../../media/images/reaction/angry.svg';
import ask from '../../../media/images/reaction/ask.svg';
import tick from '../../../media/images/reaction/tick.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { Emoji_Mutation } from '../../../apollo/Mutations';
import { setActiveMsg, setPopup, update_messages } from '../../../redux/messageSlice';

export default function EmojiContainer() {
    const dispatch = useDispatch();
    const { active_msg } = useSelector((state) => state.message);

    const [update] = useMutation(Emoji_Mutation);
    const addReaction = async (type) => {
        let { data } = await update(
            {
                variables: {
                    input: {
                        conversation_id: active_msg?.conversation_id,
                        msg_id: active_msg?.msg_id,
                        emoji: type,
                        is_reply_msg: active_msg?.is_reply_msg,
                        root_msg_id: active_msg?.reply_for_msgid,
                        participants: active_msg?.participants
                    }
                }
            }
        )
        dispatch(update_messages(
            {
                conversation_id: active_msg?.conversation_id,
                msg_id: active_msg?.msg_id,
                fields: {
                    has_emoji: data.emoji.has_emoji
                },
                is_reply_msg: active_msg?.is_reply_msg,
                msg_type: active_msg?.msg_type
            }
        ))
        dispatch(setPopup({ key: 'msg_drawer', value: false }))
        dispatch(setActiveMsg(null))
    }

    return (
        <div className="flex items-center justify-between w-full">
            <div className="msgReactionChat" data-for={'thumbsup_tooltip'} onClick={() => addReaction("thumbsup")}>
                <span role="img" aria-label="thumbsup" className="msgReactionIconChat" data-name="thumbsup">
                    <img className='!w-6' title='Like' src={like} alt='like' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'heart_tooltip'} onClick={() => addReaction("heart")}>
                <span role="img" aria-label="heart" className="msgReactionIconChat" data-name="heart">
                    <img className='!w-6' title='Love' src={love} alt='love' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'joy_tooltip'} onClick={() => addReaction("joy")}>
                <span role="img" aria-label="joy" className="msgReactionIconChat" data-name="joy">
                    <img className='!w-6' title='Care' src={care} alt='care' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'open_mouth_tooltip'} onClick={() => addReaction("open_mouth")}>
                <span role="img" aria-label="open_mouth" className="msgReactionIconChat" data-name="open_mouth">
                    <img className='!w-6' title='Wow' src={wow} alt='wow' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'grinning_tooltip'} onClick={() => addReaction("grinning")}>
                <span role="img" aria-label="grinning" className="msgReactionIconChat" data-name="grinning">
                    <img className='!w-6' title='Haha' src={haha} alt='haha' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'disappointed_relieved_tooltip'} onClick={() => addReaction("disappointed_relieved")}>
                <span role="img" aria-label="disappointed_relieved" className="msgReactionIconChat" data-name="disappointed_relieved">
                    <img className='!w-6' title='Sad' src={sad} alt='sad' />
                </span>

            </div>
            <div className="msgReactionChat" data-for={'rage_tooltip'} onClick={() => addReaction("rage")}>
                <span role="img" aria-label="rage" className="msgReactionIconChat" data-name="rage">
                    <img className='!w-6' title='Angry' src={angry} alt='angry' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'folded_hands_tooltip'} onClick={() => addReaction("folded_hands")}>
                <span role="img" aria-label="folded_hands" className="msgReactionIconChat" data-name="folded_hands">
                    <img className='!w-6' title='Ask' src={ask} alt='ask' />
                </span>
            </div>
            <div className="msgReactionChat" data-for={'check_mark_tooltip'} onClick={() => addReaction("check_mark")}>
                <span role="img" aria-label="check_mark" className="msgReactionIconChat" data-name="check_mark">
                    <img className='!w-6' title='Tick' src={tick} alt='tick' />
                </span>
            </div>
        </div>
    );
}